module.exports = __webpack_public_path__ + "static/media/logo.5f2e8521.png";